const ShopifyPlus = {
    "heroSection":{
        "enable": true,
        "title":"SHOPIFY PLUS",
        "subtext":"<strong>Get your online store<br/> ready</strong> from the<br/> Shopify plus experts",
        "image": require('../images/shopify-plus/shopify_plus_img-1.png'),
        "class": "move-from-right"
    },
    "statistics": {
        "enable": true,
        "stats": [
            {
                "count": "300+",
                "content": "Projects<br/> across"
            },
            {
                "count": "50+",
                "content": "Talented,<br/> team"
            },
            {
                "count": "1000+",
                "content": "Happy Customers"
            }
        ]
    },
    "textQuoteWithImage":{
        "enable": true,
        "text" :"A bunch of creative rebels who believe design can empower people, businesses, society and world at large.",
        "image": require('../images/shopify-plus/shopify_plus_img-2.png'),
        "classes": "bounce-up-down-2",
        "logo": require('../images/client-logos/shopify_plus_logo.png')
    },
    "iconsWithHeadingText": {
        "enable": true,
        "title": "Why Shopify Plus?",
        "subheading": "WE’RE Shopify Plus experts",
        "blocks":[
            {
                "src": require('../svgs/support-2.svg'),
                "heading": "SUPPORT WHEN YOU NEED IT",
                "content": "With a dedicated Account Manager and instant 24/7 support service via priority phone and email, your business is covered around the clock."
            },
            {
                "src": require('../svgs/zero-transactions.svg'),
                "heading": "ZERO TRANSACTION FEES",
                "content": "With Shopify Plus, transaction fees are a thing of the past. which means you can keep more of your sales dollars where they belong (in your pocket)."
            },
            {
                "src": require('../svgs/unlimited-bandwidth.svg'),
                "heading": "UNLIMITED BANDWIDTH",
                "content": "Even during high-volume times, you have the peace of mind of knowing Shopify Plus can handle thousands of orders per minute."
            },
            {
                "src": require('../svgs/seamless-integration.svg'),
                "heading": "SEAMLESS INTEGRATIONS",
                "content": "Get early access to new features, exclusive Shopify Plus APIs and increased API limits. Their robust API makes it easy to build custom integrations to suit your needs."
            },
            {
                "src": require('../svgs/shopify-scripts.svg'),
                "heading": "ACCESS TO SHOPIFY SCRIPTS",
                "content": "Modify the prices and properties of line items in your customer’s cart using Shopify Scripts and add discounts, special offers, and price breaks on multiple purchases."
            },
            {
                "src": require('../svgs/sell.svg'),
                "heading": "SELL FROM ANYWHERE, ANYTIME",
                "content": "With functionality in-store, online, on social platforms, in multiple regions and in many different languages, multi-channel sales are now easier than ever."
            }
        ]
    },
    "headingWithGrid":{
        "enable": true,
        "title": "We are experts in",
        "columns": 3,
        "theme": "dark",
        "blocks": [
            {
            "src": require('../images/shopify-plus/template-based.jpg'),
            "title": "TEMPLATE BASED DESIGN"
            },
            {
            "src": require('../images/shopify-plus/custom-template.jpg'),
            "title": "CUSTOM TEMPLATE DESIGN"
            },
            {
            "src": require('../images/shopify-plus/fully-custom.jpg'),
            "title": "FULLY CUSTOM DESIGN"
            }
        ]
    },
    "services":{
        "enable": true,
        "title": "<strong>We love working,</strong> on custom shopify apps.<br/> Below are some of features.",
        "subheading": "Shopify Plus services",
        "list":["Shopping Cart", "Shipping Returns", "Multi Screen", "Universal Login", "SEO/SEM", "Hosting", "Server Management", "Analytics", "Content Management", "Loyalty & Rewards", "Media", "Social Media", "Alerts & Notifications", "Location & Services"]
    }

};

export default ShopifyPlus;